const styles = {
    root: {
        display: 'inline-flex',
        alignItems: 'center',
        // fontFamily: 'monospace',
        // fontWeight: 'bold',
        overflow: 'hidden',
        whiteSpace: 'nowrap'
    },
    letter: {
        display: 'inline-block',
        animationName: '$disappearingLetters',
        animationDuration: '1.8s',
        animationIterationCount: 'infinite',
        animationTimingFunction: 'linear'
    },
    space: {
        width: '0.35em'
    },
    '@keyframes disappearingLetters': {
        '0%, 100%': {
            opacity: 0.2
        },
        '40%, 60%': {
            opacity: 1
        }
    }
}

export default styles
